export const ru = {
    beta_test_notification: 'Сервис на стадии бета-тестирования. Мы активно дорабатываем его и очень ждем ваш ',
    create_trip: 'Создать заявку',
    create_trip_description: 'Сформируйте корзину услуг заявки',
    feedback: 'фидбек.',
    my_trips: 'Мои заявки',
    trips_loading: 'Загрузка командировок',
};
